import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_SELLER_PERMISSIONS,
} from '../../../actions/actionTypes';

const sellerPermissions = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_SELLER_PERMISSIONS
);

export default sellerPermissions;
